<mat-select (valueChange)="rangeChanged.emit($event)" [value]="7">
  <mat-option [value]="7">
    Last 7 Days
  </mat-option>
  <mat-option [value]="30">
    Last 30 days
  </mat-option>
  <mat-option [value]="1">
    Yesterday
  </mat-option>
  <mat-option [value]="90">
    Last 90 days
  </mat-option>
  <mat-option [value]="120">
    Last 120 days
  </mat-option>
</mat-select>
